// extracted by mini-css-extract-plugin
export var container = "_dp-1";
export var cornerButtonContainer = "_dp-6";
export var disabled = "_dp-2";
export var dragActive = "_dp-3";
export var fileContainer = "_dp-5";
export var hiddenInput = "_dp-4";
export var widthContainer = "_dp-0";